import React, { forwardRef } from 'react'
import { Item, ItemIcon, ItemTitle, ItemInfo, Icon } from '~ui';
import { ShortDate } from '~modules/format/date'

function RecentItem({ item: { query, date }, forwardedRef, ...etc }) {
    return (
        <Item 
            ref={forwardedRef}
            {...etc}>
            <ItemIcon className={'ui-recent-icon'}>
                <Icon name='search' />
            </ItemIcon>

            <ItemTitle>
                {query}
            </ItemTitle>

            <ItemInfo>
                <ShortDate date={date} />
            </ItemInfo>
        </Item>
    )
}

export default forwardRef((props, ref) => {
    return <RecentItem {...props} forwardedRef={ref} />
})